import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AuthService from "../services/AuthService";
import _ from 'lodash';
import styles from './ShipmentListPage.module.scss';

function ShipmentListItem(props) {

    const [icon, setIcon] = useState("");
    const [statusText, setStatusText] = useState("");

    let history = useHistory();

    useEffect(() => {
        var status = props.shipment.shipment.status;

        if (status === 'Cancelled' || status === 'Ordered') {
            setStatusText(<span>Ordered</span>);
            setIcon("icon-timeline-pickup");
        }

        if (status === 'PickedUp') {
            setStatusText(<span>Picked<br/>up</span>);
            setIcon("icon-timeline-pickup");
        }

        if (status === "OFD" || status === "OFDOffSchedule") {
            setStatusText(<span>On the way</span>);
            setIcon("icon-timeline-ofd");
        }
            
        if (status === "PartialPOD" || status === "DriverNear") {
            setStatusText(<span>Close to home</span>);
            setIcon("icon-timeline-near");
        }
            
        if (status === "Delivered" || status === "ManualPOD") {
            setStatusText(<span>Delivered</span>);
            setIcon("icon-timeline-delivered");
        }
            
        if (status === "Rejected") {
            setStatusText(<span>Returned</span>);
            setIcon("icon-timeline-cross");
        }

    }, [props.shipment.shipment.status]);

    const onClick = () => {
        history.push(`/o/${props.shipment.token}`);
    };

    return (
        <div className={`${styles.listItem}`} onClick={onClick}>
            <div className="row">
                <div className="col-3 col-sm-2 col-xs-3">
                    <div className="step-icon">
                        <div className={`${styles.shipmentStatusIcon} icon ${icon}`}></div>
                        <div className={`${styles.shipmentStatusText}`}>{statusText}</div>
                    </div>
                </div>
                <div className="col-9 col-sm-10 col-xs-9">
                    <div className="fakeinput">                        
                        <div className="row">
                            <div className="col-6">From:&nbsp;{props.shipment.data.from.line1}</div>
                            <div className="col-6 connum">Ref:&nbsp;{props.shipment.data.connote}</div>
                        </div>
                        {
                            props.shipment.data.goods &&
                            _.map(props.shipment.data.goods, g => <div key={g.type} className="row"><span className="col-12" key={g.type}>{g.type} x{g.qty}</span></div>)
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

function ShipmentList(props) {

    const [shipmentList, setShipmentList] = useState([]);

    useEffect(() => {
        var sortedShipmentList = null;

        if (props.shipmentList) {
            sortedShipmentList = _.sortBy(props.shipmentList, [s => s.data.issued_on, s => s.data.connote]);
        }

        setShipmentList(sortedShipmentList);
    }, [props.shipmentList]);

    

    return (
        <div id="shipmentList">
            {
                shipmentList.map(s => <ShipmentListItem key={s.id} shipment={s} />)
            }
        </div>
        );
}

export default function ShipmentListPage(props) {

    const [jobs, setJobs] = useState([]);
    let history = useHistory();

    useEffect(() => {        
        var populateJobs = async () => {            
            var authService = await AuthService.getInstance();
            //console.log('authSerice', authService);
            var user = await authService.getAuthenticatedUser(false);
            //console.log('user', user);
            if(user === null) {
                console.log('user is null so empty jobs!');
                setJobs([]);
            }
            else {
                const headers = new Headers();
                headers.append('Content-Type', 'application/json');
                headers.append('Authorization', `Bearer ${user.access_token}`);
                var jobResp = await window.fetch('api/shipment/MyShipments', {method: 'GET', headers: headers});
                if(jobResp.status === 200) {
                    setJobs(await jobResp.json());
                }
                else if(jobResp.status === 400) {
                    alert("Please complete your preferences");
                    history.push('/Preferences');
                }
                else if(jobResp.status === 401) {
                    console.log('401 error logged, but ignore because silent refresh.');
                }
                else {
                    console.error('failed to get jobs ' + jobResp.status);
                    alert('Failed to get jobs for unknown reason');
                }
            }
        };
        populateJobs();
    }, []);

    return (
        <div>
            <div className="header condensed">
                My Deliveries<br/>
                <span className="sub">Tap one for more details</span>
            </div>
            <ShipmentList shipmentList={jobs} />
        </div>
        );
}